import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SEOHead from "@/components/base/SEOHead";
import SchemaOrg from "@/components/base/SchemaOrg";
import { testimonials } from "@/mocks/articles";

export default function About() {
  const avatarImages: Record<string, string> = {
    "testimonial-1": "https://readdy.ai/api/search-image?query=young%20Chinese%20woman%20expressing%20excitement%20and%20satisfaction%2C%20warm%20lighting%2C%20casual%20style%2C%20clean%20cream%20background%2C%20editorial%20portrait%2C%20genuine%20happy%20expression%2C%20friendly%20approachable&width=400&height=500&seq=about-test-1&orientation=portrait",
    "testimonial-2": "https://readdy.ai/api/search-image?query=professional%20middle%20aged%20Chinese%20man%20giving%20testimonial%2C%20confident%20trustworthy%20expression%2C%20warm%20studio%20lighting%2C%20clean%20cream%20background%2C%20editorial%20portrait%2C%20experienced%20media%20professional&width=400&height=500&seq=about-test-2&orientation=portrait",
    "testimonial-3": "https://readdy.ai/api/search-image?query=young%20Chinese%20female%20college%20student%20with%20bright%20enthusiastic%20smile%2C%20youthful%20casual%20style%2C%20warm%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20portrait%2C%20energetic%20fresh%20look&width=400&height=500&seq=about-test-3&orientation=portrait",
  };

  const faqData = [
    {
      q: "51爆料是一个什么样的平台？",
      a: "51爆料是一个专注于娱乐八卦、网红动态和黑料追踪的内容聚合平台。我们汇集51爆料网、51爆料吃瓜等多个优质内容源，每日更新网红大赛实时排名和全网最热八卦资讯，为你提供一站式吃瓜体验。",
    },
    {
      q: "51爆料的内容来源是什么？",
      a: "我们的内容来源于多个渠道，包括51爆料网原创报道、全网社交媒体热门内容聚合、用户投稿以及合作媒体提供的独家爆料。所有内容均经过编辑团队审核，确保信息的真实性和可读性。",
    },
    {
      q: "如何向51爆料投稿？",
      a: "你可以通过我们的官方邮箱 contact@51baoliao.com 提交爆料线索或原创内容。我们会对每一份投稿进行认真审核，优质的爆料内容将在平台显著位置展示，并标注来源。",
    },
    {
      q: "51爆料每日大赛是如何排名的？",
      a: "每日大赛排名基于多维度数据综合计算，包括内容热度、网友互动量、话题讨论度以及编辑团队的专业评审。排名每日凌晨更新，确保用户看到的是最新、最热的内容。",
    },
    {
      q: "51爆料的内容更新频率如何？",
      a: "我们的编辑团队7×24小时不间断追踪全网热点，确保在第一时更新最新爆料。核心栏目如网红每日大赛、黑料追踪等保持每日更新，热门事件将实时跟踪报道。",
    },
  ];

  return (
    <>
      <SEOHead
        title="关于我们 - 51爆料 | 品牌介绍、商务合作与联系方式"
        description="了解51爆料——全网吃瓜第一站。聚合51爆料网、51爆料吃瓜及全网反差不设防的吃瓜视频，提供最及时的娱乐八卦和黑料追踪服务。商务合作请联系我们。"
        keywords="51爆料关于我们,51爆料品牌介绍,51爆料商务合作,51爆料联系方式,51爆料口碑"
        canonicalUrl="/about"
      />
      <SchemaOrg
        type="AboutPage"
        data={{
          name: "关于51爆料",
          url: "https://www.51baoliao.com/about",
          description: "了解51爆料——全网吃瓜第一站。聚合51爆料网、51爆料吃瓜及全网反差不设防的吃瓜视频。",
          isPartOf: {
            "@type": "WebSite",
            name: "51爆料",
            url: "https://www.51baoliao.com",
          },
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: faqData.map((item) => ({
            "@type": "Question",
            name: item.q,
            acceptedAnswer: {
              "@type": "Answer",
              text: item.a,
            },
          })),
        }}
      />

      <main>
        <Navbar />

        <section className="pt-20 md:pt-24 pb-10 md:pb-16 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <Breadcrumb items={[{ label: "关于我们" }]} />

            <div className="mt-8 flex flex-col lg:flex-row gap-10">
              <div className="lg:w-3/5">
                <h1 className="text-3xl md:text-4xl font-heading font-black text-foreground-900 leading-tight">
                  51爆料
                  <br />
                  <span className="text-primary-500">全网吃瓜第一站</span>
                  <br />
                  <span className="text-2xl md:text-3xl text-foreground-700">黑料追踪集合站</span>
                </h1>

                <div className="mt-8 grid grid-cols-3 gap-6">
                  <div className="text-center p-4 border-r border-background-200/70">
                    <p className="text-3xl md:text-4xl font-heading font-black text-primary-500">10000+</p>
                    <p className="mt-1 text-xs text-foreground-500">黑料收录</p>
                  </div>
                  <div className="text-center p-4 border-r border-background-200/70">
                    <p className="text-3xl md:text-4xl font-heading font-black text-accent-500">500+</p>
                    <p className="mt-1 text-xs text-foreground-500">网红追踪</p>
                  </div>
                  <div className="text-center p-4">
                    <p className="text-3xl md:text-4xl font-heading font-black text-secondary-500">24H</p>
                    <p className="mt-1 text-xs text-foreground-500">实时更新</p>
                  </div>
                </div>

                <div className="mt-8">
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    51爆料成立于2024年，是国内领先的娱乐八卦内容聚合平台。我们致力于为用户提供最全面、最及时的网红动态追踪、明星八卦资讯和黑料追踪服务。平台聚合51爆料网、51爆料吃瓜等多个优质内容源，每日更新网红每日大赛实时排名，让你不错过任何一个精彩的吃瓜瞬间。
                  </p>
                  <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                    我们的编辑团队由资深娱乐记者、社交媒体分析师和内容策划专家组成，全天候跟踪全网热点，确保每一条爆料都经过严格核实。无论是网红反差视频、明星恋情曝光还是行业黑料追踪，51爆料都为你第一时间呈现。
                  </p>
                </div>
              </div>

              <div className="lg:w-2/5">
                <div className="bg-gradient-to-br from-primary-100/80 via-accent-100/60 to-secondary-100/70 rounded-2xl p-8 h-full flex flex-col justify-center">
                  <div className="space-y-4">
                    <div className="w-16 h-16 rounded-2xl bg-primary-500/20 flex items-center justify-center">
                      <i className="ri-shield-check-line text-2xl text-primary-500"></i>
                    </div>
                    <h3 className="text-lg font-heading font-bold text-foreground-900">我们的使命</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      让每一个吃瓜群众都能第一时间获取最真实、最劲爆的娱乐资讯。我们相信，好的爆料应该被更多人看到。
                    </p>
                  </div>
                  <div className="mt-6 space-y-3">
                    <div className="flex items-center gap-3 p-3 bg-background-50/80 rounded-lg">
                      <i className="ri-eye-line text-primary-500"></i>
                      <span className="text-sm text-foreground-700">日均访问量 500万+</span>
                    </div>
                    <div className="flex items-center gap-3 p-3 bg-background-50/80 rounded-lg">
                      <i className="ri-user-heart-line text-accent-500"></i>
                      <span className="text-sm text-foreground-700">忠实用户 200万+</span>
                    </div>
                    <div className="flex items-center gap-3 p-3 bg-background-50/80 rounded-lg">
                      <i className="ri-article-line text-secondary-500"></i>
                      <span className="text-sm text-foreground-700">累计爆料 10000+篇</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-background-100">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10">
              <div className="lg:w-1/2 relative rounded-lg overflow-hidden h-64 md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20newsroom%20with%20multiple%20monitors%20showing%20social%20media%20feeds%2C%20warm%20red%20and%20gold%20accent%20lighting%2C%20modern%20media%20office%20atmosphere%2C%20dynamic%20editorial%20environment%2C%20professional%20yet%20creative%20workspace%2C%20cinematic%20composition&width=800&height=600&seq=about-cta&orientation=landscape"
                  alt="51爆料编辑部"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>
                <div className="absolute bottom-6 left-6">
                  <span className="text-xs font-label text-background-50/80">深度追踪</span>
                  <p className="text-xl md:text-2xl font-heading font-black text-background-50 leading-tight mt-1">
                    独家爆料
                    <br />
                    反差揭秘
                    <br />
                    实时更新
                  </p>
                </div>
              </div>

              <div className="lg:w-1/2 flex flex-col justify-center">
                <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-900">
                  成为爆料合伙人
                </h2>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  你有第一手爆料线索？你是某个领域的知情人士？加入51爆料合伙人计划，让你的声音被更多人听到。我们为优质爆料提供丰厚稿酬和全方位推广支持。
                </p>
                <div className="mt-5">
                  <a
                    href="mailto:contact@51baoliao.com"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-label text-sm rounded-full whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                  >
                    联系我们
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-900 text-center mb-3">
              商务合作
            </h2>
            <p className="text-sm text-foreground-500 text-center max-w-xl mx-auto mb-10">
              51爆料欢迎各类商务合作，包括广告投放、内容合作、品牌推广等多种形式
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
              <div className="bg-background-100 rounded-xl p-5 text-center hover:bg-background-200/70 transition-colors">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mx-auto">
                  <i className="ri-advertisement-line text-xl"></i>
                </div>
                <h3 className="mt-3 font-label font-medium text-foreground-900 text-sm">广告投放</h3>
                <p className="mt-1 text-xs text-foreground-500">首页Banner、信息流广告等多种广告位可选</p>
                <a href="mailto:ad@51baoliao.com" className="mt-3 inline-block text-xs text-primary-500 hover:text-primary-600 font-label cursor-pointer">
                  ad@51baoliao.com
                </a>
              </div>
              <div className="bg-background-100 rounded-xl p-5 text-center hover:bg-background-200/70 transition-colors">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mx-auto">
                  <i className="ri-service-line text-xl"></i>
                </div>
                <h3 className="mt-3 font-label font-medium text-foreground-900 text-sm">内容合作</h3>
                <p className="mt-1 text-xs text-foreground-500">原创内容联合制作、独家报道授权发布</p>
                <a href="mailto:content@51baoliao.com" className="mt-3 inline-block text-xs text-accent-500 hover:text-accent-600 font-label cursor-pointer">
                  content@51baoliao.com
                </a>
              </div>
              <div className="bg-background-100 rounded-xl p-5 text-center hover:bg-background-200/70 transition-colors">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mx-auto">
                  <i className="ri-megaphone-line text-xl"></i>
                </div>
                <h3 className="mt-3 font-label font-medium text-foreground-900 text-sm">品牌推广</h3>
                <p className="mt-1 text-xs text-foreground-500">定制化品牌整合营销方案，精准触达目标用户</p>
                <a href="mailto:brand@51baoliao.com" className="mt-3 inline-block text-xs text-secondary-500 hover:text-secondary-600 font-label cursor-pointer">
                  brand@51baoliao.com
                </a>
              </div>
              <div className="bg-background-100 rounded-xl p-5 text-center hover:bg-background-200/70 transition-colors">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mx-auto">
                  <i className="ri-user-add-line text-xl"></i>
                </div>
                <h3 className="mt-3 font-label font-medium text-foreground-900 text-sm">人才招聘</h3>
                <p className="mt-1 text-xs text-foreground-500">加入51爆料团队，一起做最劲爆的娱乐内容</p>
                <a href="mailto:hr@51baoliao.com" className="mt-3 inline-block text-xs text-primary-500 hover:text-primary-600 font-label cursor-pointer">
                  hr@51baoliao.com
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-background-100">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-900 text-center mb-10">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((item) => (
                <div
                  key={item.id}
                  className="bg-background-50 rounded-xl p-5 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={avatarImages[item.avatarSeq] || avatarImages["testimonial-1"]}
                      alt={item.user}
                      className="w-12 h-12 rounded-full object-cover"
                      loading="lazy"
                    />
                    <div>
                      <p className="text-sm font-label font-medium text-foreground-900">{item.user}</p>
                      <p className="text-xs text-foreground-400">{item.userTag}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                    &ldquo;{item.content}&rdquo;
                  </p>
                  <div className="mt-3 flex text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-fill text-xs"></i>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-900 text-center mb-10">
              常见问题
            </h2>
            <div className="max-w-3xl mx-auto space-y-4">
              {faqData.map((faq, index) => (
                <div key={index} className="bg-background-100 rounded-lg p-5">
                  <h3 className="font-label font-medium text-foreground-900 text-sm">
                    {faq.q}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-background-100">
          <div className="px-4 md:px-6 max-w-7xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-900">
              联系我们
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              如果你有任何问题、建议或合作意向，欢迎通过以下方式联系我们
            </p>
            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5 max-w-3xl mx-auto">
              <div className="bg-background-50 rounded-xl p-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mx-auto">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <h3 className="mt-3 font-label font-medium text-foreground-900 text-sm">公司地址</h3>
                <p className="mt-1 text-xs text-foreground-500">北京市朝阳区互联网产业园区</p>
              </div>
              <div className="bg-background-50 rounded-xl p-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mx-auto">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <h3 className="mt-3 font-label font-medium text-foreground-900 text-sm">客服电话</h3>
                <p className="mt-1 text-xs text-foreground-500">400-888-5151</p>
              </div>
              <div className="bg-background-50 rounded-xl p-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mx-auto">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="mt-3 font-label font-medium text-foreground-900 text-sm">电子邮箱</h3>
                <p className="mt-1 text-xs text-foreground-500">contact@51baoliao.com</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}